import { Component, OnInit, OnDestroy } from '@angular/core';

import { Empresa } from '../../cadastro/model/empresa.model';
import { Subscription } from 'rxjs/Subscription';
import { SelectItem } from 'app/shared/common/select-item.interface';
import { TitleService } from 'app/shared/services/title.service';
import { ToolbarService } from 'app/shared/services/toolbar.service';
import { UtilService } from 'app/shared/services/util.service';
import { ConfigService } from 'app/shared/services/config.service';
import { HttpService } from 'app/shared/services/http.service';
import { SessionService } from 'app/shared/services/session.service';
import { DblinkedSessionService } from 'app/shared/services/dblinked-session.service';
import { ToolbarButton } from 'app/shared/model/toolbar-button.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Message, MessageService } from '../../../../node_modules/primeng/api';
import { Toolbar } from 'app/shared/model/toolbar.model';

@Component({
  selector: 'app-acesso',
  templateUrl: './acesso.component.html',
  styleUrls: ['./acesso.component.scss'],
})
export class AcessoComponent implements OnInit, OnDestroy {
  private sessionSubscription: Subscription;

  msgs: Message[] = [];

  titlePrincipal: string;
  subtitle: string;

  listaUsuarios: Array<any> = new Array();
  listaAprovadores: Array<any> = new Array();

  relatorios: SelectItem[];
  reportId: number;

  listaUsuariosRelacionar: Array<any> = new Array();
  listaUsuariosRelacionados: Array<any> = new Array();

  picklistState: boolean = true

  constructor(private titleService: TitleService,
    private configService: ConfigService,
    private toolbarService: ToolbarService,
    private httpService: HttpService,
    private utilService: UtilService,
    private sessionService: SessionService,
    private modalService: NgbModal,
    private dblinkedSessionService: DblinkedSessionService,
    private messageService: MessageService) {
  }

  public toolbarMain = new Toolbar()

  toolbarMainIni = [
    { key: "save", icon: 'save', text: 'Salvar', tooltip: 'Salvar', visible: true, disabled: false, color: 'default', onClick: () => this.salvarRelacionamento() },
  ]

  ngOnInit(): void {
    // requisição
    this.toolbarMain.setAll(this.toolbarMainIni)
    this.toolbarService.hidden = true
    this.titlePrincipal = 'CONFIGURAÇÕES';
    this.subtitle = 'ACESSOS À RELATÓRIOS';
    this.titleService.title = 'CONFIGURAR ACESSOS PARA RELATÓRIOS POWERBI';
    this.dblinkedSessionService.showPeriodsWithNextMonths(true, true, 24, 1, 2);
    this.reportId = 0;

    this.sessionSubscription = this.sessionService.initSubscribe(this.dblinkedSessionService.sessionChanged, () => {
      this.change();
    });
  }

  ngOnDestroy() {
    this.sessionService.destroySubscribe(this.sessionSubscription);
  }

  change() {
    if (this.dblinkedSessionService.hasEmpresaSelected &&
      this.dblinkedSessionService.hasPeriodoSelected && this.dblinkedSessionService.periodo.month
      && this.dblinkedSessionService.periodo.year) {

      this.listaUsuariosRelacionar = new Array();
      this.listaUsuariosRelacionados = new Array();

      this.relatorios = [];
      this.relatorios.push({ label: 'Selecione', value: 0 });

      this.httpService.wait();
      this.httpService.get('custom/pbi/listar-relatorios')
        .subscribe(retorno => {
          retorno.forEach(element => {
            this.relatorios.push({ label: element.nome, value: element.id });
          });

        }, error => this.httpService.handleError(error, () => this.change()),
          () => this.httpService.done());
      // renderizando a toolbar
      this.toolbarEdit();
    }
  }

  export() {
    // alert('export');
    return true
  }

  pesquisa() {
    // alert('pesquisa');
    return true
  }


  hideMessage() {
    this.msgs = [];
  }

  toolbarEdit() {
    this.toolbarService.ocultar('cancel');
    this.toolbarService.ocultar('check');
    this.toolbarService.ocultar('info');
    this.toolbarService.ocultar('msg');
    this.toolbarService.ocultar('alterar');
    this.toolbarService.alterarStatus('pesquisa', true, 'Detalhes Rateio', () => this.pesquisa());
    // this.toolbarService.alterarStatus('download', true, 'Download Anexos', () => this.export());
    this.toolbarService.alterarStatus('voltar', true, 'Voltar', () => this.ngOnInit());
    this.toolbarService.alterarStatus('atualizar', true, 'Atualizar RMS', () => this.change());
    this.toolbarService.alterarStatus('remove', true, 'Excluir', () => this.ngOnInit());
    this.toolbarService.alterarStatus('save', true, 'Salvar requisição', () => this.ngOnInit());
    this.toolbarService.alterarStatus('edit', true, 'Editar requisição', () => this.ngOnInit());
    this.toolbarService.replace('add', false, 'class-new-button', 'SALVAR', 'Salvar Aprovadores', () => this.salvarRelacionamento());
  }

  get empresa(): Empresa {
    return this.dblinkedSessionService.empresa;
  }

  get buttons(): Array<ToolbarButton> {
    return this.toolbarService.buttons;
  }

  get rowsPerPage() {
    return this.configService.applicationConfig.rowsPerPage;
  }

  get rows() {
    return this.configService.applicationConfig.rows;
  }

  get pageLinks() {
    return this.configService.applicationConfig.pageLinks;
  }

  salvarRelacionamento() {
    if (confirm('Deseja realmente salvar este relacionamento?')) {
      const req = {
        reportId: this.reportId,
        listaUsuariosRelacionar: this.listaUsuariosRelacionar,
        listaUsuariosRelacionados: this.listaUsuariosRelacionados
      };


      this.httpService.wait();
      this.httpService.post('/custom/pbi/salvar-relacionamento', req)
        .subscribe(result => {
          let existeErro = false;
          result.forEach(element => {
            if (element.error) {
              existeErro = true;
              this.messageService.add({
                severity: element.severity,
                summary: 'MSG: ',
                detail: element.message
              });
            }
          });
          if (!existeErro) {
            this.messageService.add({
              severity: 'success', key: 'messageLinnks',
              summary: 'MSG: ',
              detail: 'Alteração salva com sucesso!'
            });
          }


          this.change();
        },
          error => this.httpService.handleError(error, () => this.salvarRelacionamento()),
          () => this.httpService.done());
    }
  }

  tabChange(event: any) {

    if (event.index === 0) {
      this.toolbarService.replace('add', false, 'class-new-button', 'SALVAR', 'Salvar Relacionamento', () => this.salvarRelacionamento());
    }
  }

  buscarUsuarios() {

    this.listaUsuariosRelacionados = new Array();
    this.listaUsuariosRelacionar = new Array();

    this.picklistState = false

    if (this.reportId > 0) {
      this.httpService.wait();
      this.httpService.get('custom/pbi/listar-usuarios-relacionados',
        [this.reportId])
        .subscribe(retorno => {
          retorno.forEach(element => {
            if (element.relac) {
              this.listaUsuariosRelacionados.push(element);
            } else {
              this.listaUsuariosRelacionar.push(element);
            }
          });

          this.picklistState = true
        }, error => this.httpService.handleError(error, () => this.change()),
          () => this.httpService.done());
    } else {
      this.picklistState = true
    }
  }
}
